export default "../images/stackloans-partners-with-Prosper_PORTAL_US.png?e7c5bfa296367c807709a8730b61df3e";